import { ImageEditor } from "../imageeditor";

export class BaseModule {

  /**
   * @type {ImageEditor}
   */
  imageEditor = null;

  /**
   * Listeners
   */
  listeners = {};

  /**
   * Constructor.
   * @param {ImageEditor} imageEditor 
   */
  constructor(imageEditor){
    this.imageEditor = imageEditor;
  }

  /**
   * Register a listener to an event.
   * @param {String} event Event name
   * @param {Function} callback Callback function
   */
  on(event, callback) {
    if(this.listeners[event] == undefined) this.listeners[event] = [];
    this.listeners[event].push(callback);
  }

  /**
   * Emit an event to all registered listeners.
   * @param {String} event Event name
   * @param {any} data Data to transfer
   */
  emit(event, data) {
    if(this.listeners[event] == undefined) return;
    for (const callback of this.listeners[event]) {
      callback(data);
    }
  }

}